var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-header"},[_c('div',{staticClass:"module-title"},[_c('img',{staticClass:"module-title-icon",attrs:{"src":require("@/assets/data-center/title-icon.png")}}),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('img',{staticClass:"module-header-line",attrs:{"src":require(`@/assets/data-center/${_vm.lineIcon}.png`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }